import makeStyles from "@mui/styles/makeStyles";

const useStyle = makeStyles((theme) => ({
  imageContainer: {
    width: "100%",
    height: "144px",
    position: "relative",
    overflow: "hidden",
    borderRadius: 15,
  },
  imgContainer: {
    backgroundSize: "cover",
    backgroundPositionX: "50%",
    backgroundPositionY: "center",
    transition: "transform 0.2s",
    height: "100%",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  timeText: {
    ...theme.typography.caption,
    fontSize: "0.5rem",
    textAlign: "center",
    lineHeight: "normal",
    display: "inline",
    fontWeight: 700,
  },
  timeContainer: {
    padding: "5px 10px",
    backgroundColor: theme.palette.primary.light,
    position: "absolute",
    left: "10px",
    top: "10px",
    borderRadius: "0.75rem",
  },
  closedBanner: {
    position: "absolute",
    top: 0,
    left: "0px",
    right: "0px",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "10px",
    padding: "7px 12px",
    opacity: 0.95,
    zIndex: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  closedBannerText: {
    ...theme.typography.body2,
    color: theme.palette.common.white,
    fontWeight: 500,
    lineHeight: 1.2,
    textAlign: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  offText: {
    textAlign: "center",
    color: theme.palette.text.primary,
    fontWeight: 700,
  },
  offContainer: {
    padding: "5px 15px",
    backgroundColor: theme.palette.primary.main,
    position: "absolute",
    top: "10px",
  },
  textBold: {
    fontWeight: theme.typography.fontWeightBold,
  },
  totalRatingText: {
    color: theme.palette.text.disabled,
    fontSize: "0.875rem",
  },
  subDescription: {
    color: theme.palette.text.disabled,
    overflow: "hidden",
    fontSize: "0.875rem",
    flex: 0.9,
  },
  priceText: {
    fontWeight: 700,
    fontSize: "0.875rem",
  },
  priceDescription: {
    color: theme.palette.text.disabled,
    fontSize: "0.875rem",
  },
  heartBtn: {
    minWidth: "36px",
    height: "36px",
    borderRadius: "18px",
    backgroundColor: theme.palette.common.white,
    position: "absolute",
    top: "10px",
    right: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.palette.common.white,
    },
    "&:disabled": {
      backgroundColor: theme.palette.common.white,
    },
  },
  smallHeartBtn: {
    minWidth: "30px",
    height: "30px",
    borderRadius: "18px",
    backgroundColor: theme.palette.common.white,
    position: "absolute",
    top: "10px",
    right: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.palette.common.white,
    },
    "&:disabled": {
      backgroundColor: theme.palette.common.white,
    },
  },
  card: {
    backgroundColor: "white",
    boxShadow: theme.shadows[0],
    borderRadius: 25,
    padding: 8,
  },
  // Grid cards stretch to the tallest card in their row
  gridCard: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
  },
  gridAction: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
    paddingBottom: 12,
  },
  icon: {
    color: "black",
  },
  row: {
    marginTop: 10,
    width: "90%",
    margin: "auto",
  },
  largeWidth: {
    minWidth: 0,
    width: "100%",
  },
  smallWidth: {
    width: "200px",
    [theme.breakpoints.down("md")]: {
      width: "150px",
    },
  },
}));

export default useStyle;
